import { KalturaMediaEntry } from "kaltura-typescript-client/api/types/KalturaMediaEntry";
import { KalturaMediaType } from "kaltura-typescript-client/api/types/KalturaMediaType";
import { KalturaExternalMediaEntry } from "kaltura-typescript-client/api/types/KalturaExternalMediaEntry";
import { SearchAndSelectEntry } from "@kaltura/mediaspace-shared-types";
import { translate } from "@kaltura/mediaspace-shared-utils";

/**
 * Convert uploaded entry to S&S format
 */
export const getUploadedSearchAndSelectEntry = (entry: KalturaMediaEntry): SearchAndSelectEntry => {
    switch (entry.mediaType) {
        case KalturaMediaType.audio:
            return { entry, mediaTypeName: translate("Audio"), mediaTypeId: "audio" };
        case KalturaMediaType.image:
            return { entry, mediaTypeName: translate("Image"), mediaTypeId: "image" };
        default:
            return { entry, mediaTypeName: translate("Video"), mediaTypeId: "video" };
    }
};

/**
 * Convert YouTube entry to S&S format
 */
export const getYouTubeSearchAndSelectEntry = (entry: KalturaExternalMediaEntry): SearchAndSelectEntry => {
    return { entry, mediaTypeName: translate("YouTube"), mediaTypeId: "youtube" };
};
